import React, {useEffect, useState} from "react";
import {Modal} from "../../../../components/modal/modal.jsx";
import Button from "../../../../components/button/button.jsx";
import TaskService from "../../../../services/dispatch/task-service.js";
import projectUtils from "../../../../utils/project-utils.js";
import {formatCaseCard} from "../utils/dashboard-formatters.js";

const getErrorMessage = (error, fallback) => {
    const message = error.response?.data?.errorMessages ?? error.response?.data?.message;
    if (Array.isArray(message)) return message.join("<br />");
    return message || fallback;
};

const TaskMoveAttendanceModal = ({payload, onClose, onSuccess}) => {
    const [isSubmitting, setIsSubmitting] = useState(false);
    const open = Boolean(payload);
    const task = payload?.task ?? payload?.item ?? payload;

    useEffect(() => {
        if (!open) return;
        setIsSubmitting(false);
    }, [open]);

    const handleSubmit = async () => {
        if (!task?.id) {
            projectUtils.swalErrorMessage("Erro", "Não foi possível identificar a tarefa.", "Ok");
            return;
        }

        setIsSubmitting(true);

        try {
            await TaskService.moveTaskToAttendance(task.id);
            onSuccess();
            projectUtils.swalSuccessMessage("success", "Sucesso", "Tarefa convertida em atendimento com sucesso.", "Ok");
        } catch (error) {
            console.error("Erro ao mover tarefa para atendimento pelo dashboard:", error);
            projectUtils.swalErrorMessage("", getErrorMessage(error, "Não foi possível mover a tarefa para atendimento."), "Ok");
            setIsSubmitting(false);
        }
    };

    return (
        <Modal open={open} setOpen={onClose} title="Converter tarefa em atendimento" className="w-full max-w-2xl" isCloseClick={false}>
            <Modal.Body className="flex flex-col gap-4">
                <div>
                    <p className="text-[14px] font-bold text-[#676a6c]">Tarefa</p>
                    <div className="mt-2 flex flex-col text-sm text-[#555]">
                        <span><strong>{task?.reasonText ?? task?.reason ?? "Tarefa"}</strong></span>
                        {task?.description ? <span>{task.description}</span> : null}
                        {task?.placeText ? <span>{formatCaseCard(task.placeText)}</span> : null}
                    </div>
                </div>
            </Modal.Body>
            <Modal.Footer>
                <Button type="button" target="primary" onClick={handleSubmit} loading={isSubmitting} actionFeedbackType='save'>

                    Salvar
                </Button>
            </Modal.Footer>
        </Modal>
    );
};

export default TaskMoveAttendanceModal;